module.exports = __webpack_public_path__ + "static/media/closeWindow.d4d9fb62.svg";